import {useMutation} from '@github-ui/react-query'
import {apiUpdateIssueAssigneesBulk, type UpdateIssueAssigneesBulkRequest} from '../api/api-update-issue-assignees-bulk'
import {parseGraphQLResponse} from '@github-ui/item-picker-base/api/graphql'
import type {Assignee} from '../api/assignee'

type UseUpdateIssueAssigneesBulkMutationInput = UpdateIssueAssigneesBulkRequest & {assignees?: Assignee[]}

type UseUpdateIssueAssigneesBulkMutationOptions = {
  onMutate: (variables: UseUpdateIssueAssigneesBulkMutationInput) => void
}

export function useUpdateIssueAssigneesBulkMutation({onMutate}: UseUpdateIssueAssigneesBulkMutationOptions) {
  return useMutation({
    mutationFn: async ({assignees, ...request}: UseUpdateIssueAssigneesBulkMutationInput) => {
      const responseJson = await apiUpdateIssueAssigneesBulk(request)
      const responseData = parseGraphQLResponse(responseJson)
      return responseData
    },
    onMutate,
  })
}
